export enum JavaScriptVariableType {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Object = 'object',
  Array = 'array',
}

export interface BaseJavaScriptVariableType {
  id: string;
  createdTime: number;
  name: string;
  initialValue?: string;
  parentId?: string;
}

export interface StringTypeJavaScriptVariable extends BaseJavaScriptVariableType {
  type: JavaScriptVariableType.String;
}

export interface NumberTypeJavaScriptVariable extends BaseJavaScriptVariableType {
  type: JavaScriptVariableType.Number;
}

export interface BooleanTypeJavaScriptVariable extends BaseJavaScriptVariableType {
  type: JavaScriptVariableType.Boolean;
}

export interface ObjectTypeJavaScriptVariable extends BaseJavaScriptVariableType {
  type: JavaScriptVariableType.Object;
}

export interface ArrayTypeJavaScriptVariable extends BaseJavaScriptVariableType {
  type: JavaScriptVariableType.Array;
}

export type JavaScriptVariable =
  | StringTypeJavaScriptVariable
  | NumberTypeJavaScriptVariable
  | BooleanTypeJavaScriptVariable
  | ObjectTypeJavaScriptVariable
  | ArrayTypeJavaScriptVariable;

export type JavaScriptVariableState =
  | {
      id: string;
      name: string;
      value: unknown;
      error?: string;
    }
  | undefined;

export type ComputedJavaScriptVariableState<T> = {
  id: string;
  name: string;
  value: T;
};

interface BaseVariableTypePayload {
  variableId: string;
  method: 'setPageVariable';
}

export interface SetVariableArrayTypePayload extends BaseVariableTypePayload {
  operationDetails: {
    operation?: 'SET' | 'APPEND' | 'PREPEND' | 'POP' | 'SHIFT' | 'REMOVE_AT' | 'REMOVE_BY_VALUE';
    value?: string;
    index?: number;
  };
}

export interface SetVariableStringTypePayload extends BaseVariableTypePayload {
  operationDetails: {
    operation?: 'SET' | 'APPEND' | 'PREPEND';
    value?: string;
  };
}

export interface SetVariableNumberTypePayload extends BaseVariableTypePayload {
  operationDetails: {
    operation?: 'SET' | 'INCREMENT_BY' | 'DECREMENT_BY';
    value?: string;
  };
}

export interface SetVariableBooleanTypePayload extends BaseVariableTypePayload {
  operationDetails: {
    operation?: 'SET' | 'TOGGLE';
    value?: string;
  };
}

export interface SetVariableObjectTypePayload extends BaseVariableTypePayload {
  operationDetails: {
    operation?: 'SET' | 'MERGE' | 'REMOVE_PROPERTY';
    value?: string | string[];
  };
}

export type SetVariablePayloadType =
  | SetVariableArrayTypePayload
  | SetVariableStringTypePayload
  | SetVariableNumberTypePayload
  | SetVariableBooleanTypePayload
  | SetVariableObjectTypePayload;
